import { AppState } from "@shared/interfaces";
import { createSelector } from "reselect";
import { NicheFilesError } from "@containers/NicheFiles/interface";
import { State } from "@shared/models";

const allState = (state: AppState) => state;
const selectNicheFilesState = (state: AppState) => state.nicheFiles;

export const getNicheFiles = () => createSelector(selectNicheFilesState, (state) => state.files);

export const getNicheFilesSubscription = () => createSelector(selectNicheFilesState, (state) => state.subscription);

export const getNicheFilesSubscriptions = () => createSelector(selectNicheFilesState, (state) => state.subscriptions);

export const subscriptionsLoaded = createSelector(selectNicheFilesState, (state) => state.subscriptionsLoaded);

export const getNicheFilesCountyPrice = () => createSelector(selectNicheFilesState, (state) => state.countyPrices);

export const getNicheFilesSubscriptionTotalPrice = () =>
  createSelector(selectNicheFilesState, (state) =>
    state.subscription.county_ids.reduce((sum, c) => sum + (state.countyPrices?.[c] || 0), 0),
  );

export const getNicheFilesAvailableStates = () =>
  createSelector(
    allState,
    (state: AppState) =>
      state.shared.states
        ?.filter((s) => !state.nicheFiles.subscription.state_ids.includes(s.id))
        .map((state) => ({ value: state.id, label: state.name })) || [],
  );

export const getNicheFilesAvailableCounties = () =>
  createSelector(allState, (state: AppState) => {
    const statesById: Record<number, State> = (state.shared.states || []).reduce(
      (acc, state) => ({ ...acc, [state.id]: state }),
      {},
    );

    return (
      state.shared.counties
        ?.filter(
          (c) =>
            !state.nicheFiles.subscription.county_ids.includes(c.id) &&
            state.nicheFiles.subscription.state_ids.includes(c.state_id) &&
            state.nicheFiles.countyPrices?.[c.id],
        )
        .map((county) => ({
          value: county.id,
          label: `${county.name}, ${statesById[county.state_id]?.abbreviation}`,
        })) || []
    );
  });

export const getFilter = () => createSelector(selectNicheFilesState, (state) => state.filter);

export const selectError = (errorType: NicheFilesError) =>
  createSelector(selectNicheFilesState, (state) => state.errors[errorType]);
